import React from "react";
import { Tab, Tabs } from "@material-ui/core";
import { BILLING_V2_TABS } from "../../constants/CoreConstants";
import { tabsStyles } from "./BillingV2Style";



const ContentTabs = ({ activeTab, handleTabChange }) => {
  const classes = tabsStyles();

  return (
    <Tabs className={classes.tabs} value={activeTab} onChange={handleTabChange} style={{ marginBottom: 8 }}>
      <Tab
        className={classes.tab}
        label="Subscription"
        value={BILLING_V2_TABS.SUBSCRIPTION}
      />
      <Tab
        className={classes.tab}
        label="Payments"
        value={BILLING_V2_TABS.PAYMENTS}
      />
      <Tab
        className={classes.tab}
        label="Invoices"
        value={BILLING_V2_TABS.INVOICES}
      />
    </Tabs>
  );
};

export default ContentTabs;
